import { TMStageResponse, TMStageId } from '@business/entities/tm';
import { Endpoint } from '../endpoint';
import { TMBoardId } from '@business/entities/tm/TimeMaterialBoardResponse';
import { R } from '@core/utils/r';

export function fetchStages(boardId: TMBoardId) {
  const params = R.objectCompact({ boardId });
  return Endpoint.get<TMStageResponse[]>(`@gc/time-material/stage`, { params });
}

export function fetchStage(id: TMStageId) {
  return Endpoint.get<TMStageResponse>(`@gc/time-material/stage/stage/${id}`);
}

export function createStage(data: Partial<TMStageResponse>) {
  return Endpoint.post<TMStageResponse>(`@gc/time-material/stage`, { data });
}

export function updateStage(id: TMStageId, data: Partial<TMStageResponse>) {
  return Endpoint.patch<TMStageResponse>(`@gc/time-material/stage/${id}`, { data });
}

export function deleteStage(id: TMStageId) {
  return Endpoint.delete<void>(`@gc/time-material/stage/${id}`);
}

export function updateStatus(id: TMStageId) {
  return Endpoint.post<TMStageResponse>(`@gc/time-material/stage/status/${id}`);
}
